import IBAN from 'iban';
import React, { Component } from 'react';
import { CustomerDataFields } from '../../interfaces/CustomerData/CustomerData';
import { FormFieldFunctions } from '../../interfaces/FormField/FormField';
import Snapshot from '../../interfaces/Snapshot/Snapshot';
import FormFieldInputTextProps from './FormFieldInputText.props';
import FormFieldInputTextState from './FormFieldInputText.state';

export default class FormFieldInputText extends Component<FormFieldInputTextProps, FormFieldInputTextState> implements FormFieldFunctions {
    protected block: React.RefObject<HTMLDivElement>;
    protected input: React.RefObject<HTMLInputElement>;

    constructor(props: FormFieldInputTextProps) {
        super(props);
        this.state = {
            selected: this.props.selected || '',
            readOnly: this.props.readOnly 
                || (this.props.isLoggedIn 
                    && ((this.props.required && (this.props.selected || '').length > 0) )) 
                || false,
            type: this.props.validation === 'email'
                || this.props.validation === 'tel'
                || this.props.validation === 'password'
                ? this.props.validation
                : 'text'
        };
        this.block = React.createRef<HTMLDivElement>();
        this.input = React.createRef<HTMLInputElement>();
        this.changeHandler = this.changeHandler.bind(this);
        this.blurHandler = this.blurHandler.bind(this);
        this.toggleInputType = this.toggleInputType.bind(this);
    }

    updateAndNotify = () => {
        this.setState({
            selected: this.props.validation === 'tel' && this.props.selected ? this.processPhoneNumber(this.props.selected) : (this.props.selected ? this.props.selected : ''),
            readOnly: this.props.readOnly 
                || (this.props.isLoggedIn 
                    && ((this.props.required && (this.props.selected || '').length > 0) )) 
                || false,
        }, this.updateInput);
    }

    componentDidMount() {
        this.updateInput();
    }

    processPhoneNumber(selected: string) {
        const result = selected.replace(/\(|\)|\//g, '');
        return result.replace(/\s+/g, ' ')
    }

    getSnapshotBeforeUpdate(prevProps: FormFieldInputTextProps): Snapshot {
        return { 
            notifyRequired: prevProps.selected !== this.props.selected,
        };
    }

    componentDidUpdate(prevProps: FormFieldInputTextProps, prevState: FormFieldInputTextState, snapshot: Snapshot) {
        if (snapshot.notifyRequired) {
            this.updateAndNotify();

            // setTimeout(() => {
            //     if (this.getValue() === '') {
            //         this.setState({
            //             readOnly: false
            //         })
            //     }
            // }, 500)
        }
    }

    changeHandler(e: React.ChangeEvent<HTMLInputElement>) {
        this.setState({
            selected: e.target.value
        }, () => {
            this.updateInput();
            this.props.onChange && this.props.onChange(e);
        });
    }

    updateInput() {
        if (this.state.selected !== '') {
            this.block.current?.querySelector('input')?.classList.add('text-input__element--filled');
        } else {
            this.block.current?.querySelector('input')?.classList.remove('text-input__element--filled');
        }

        if (this.props.validation === 'iban' && IBAN.isValid(this.state.selected)) {
            this.setState({
                selected: IBAN.printFormat(this.state.selected, ' ')
            });
        }

        if (this.isValid()) {
            this.toggleValidationError(false);
        }
    }

    blurHandler(e: React.ChangeEvent<HTMLInputElement>) { 
        this.updateInput();
        if (this.props.onBlurHandler && this.props.validation === 'email') this.props.onBlurHandler(e);
    }

    isValid() {
        if (this.state === undefined || (this.props.required && this.state.selected.trim() === '')) {
            return false;
        }

        if (this.props.validation === 'iban' && !IBAN.isValid(this.state.selected)) {
            return false;
        }

        if (this.props.maxLength && this.state.selected && this.state.selected.length > this.props.maxLength) {
            this.setState({
                selected: '',
            }, () => {
                this.updateInput();
            });
            return false;
        }

        if (this.props.validation === 'email' || this.props.validation === 'tel') {
            return !!this.input.current?.validity.valid;
        }

        return true;
    }
    
    toggleValidationError(show: boolean) {
        if (show) {
            this.block.current?.parentElement?.classList.add('form__field--error');
        } else {
            this.block.current?.parentElement?.classList.remove('form__field--error');
        }
    }

    getFocus() {
        this.input.current?.focus();
    }

    getValue() {
        return this.state.selected.trim();
    }

    toggleInputType() {
        if (this.state.type === 'text') {
            this.setState({
                type: 'password',
            });
        } else {
            this.setState({
                type: 'text',
            });
        }
    }

    render(): React.ReactNode {
        return (
            <div className="text-input" ref={this.block}>
                <div className="text-input__inner">
                    <div className="text-input__content">
                        <input id={this.props.id}
                            className="text-input__element"
                            value={this.state.selected}
                            type={this.state.type}
                            data-validation={this.props.validation}
                            placeholder={this.props.label}
                            name={this.props.id}
                            required={this.props.required}
                            readOnly={this.props.id === CustomerDataFields.BILLINGMAIL ? false : this.state.readOnly}
                            autoComplete={this.props.autoComplete}
                            maxLength={this.props.maxLength}
                            onChange={(e) => this.changeHandler(e)}
                            onBlur={(e) => this.blurHandler(e)}
                            ref={this.input} />
                        <label className="text-input__label" htmlFor={this.props.id}>
                            <span className="text-input__label-text">{this.props.label}</span>
                        </label>
                        {this.props.validation === 'password' && <i className="text-input__password" onClick={this.toggleInputType}></i>}
                    </div>
                </div>
            </div>
        );
    }
}
